module.exports = __webpack_public_path__ + "../static/img/banco_del_bajio.34f68d40.png";